var React = require('react');
var PropTypes = React.PropTypes;
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import TeXEditor from '../TeXEditor/TeXEditor';
import ReactTooltip from 'react-tooltip';
import CustomEditor from "../CustomEditor/CustomEditor";
import WirisEditor from "../WirisEditor/WirisEditor";

var MIN_SOLUTION_AS_HINT = 3;

var Solution4LongQ = React.createClass({
  addSolution: function () {
    var solution = this.state.solution;
    if (this.state.asHint) {
      const lastIndex = solution.length - 1;
      const newSol = this.newSolution();
      const lastItem = solution.splice(lastIndex, 1, newSol)[0];
      solution.push(lastItem);
      this.props.onNewHintAdded(lastIndex);
    }
    else {
      solution.push(this.newSolution());
    }
    this.setState({
      solution: solution
    }, () => {
      if (this.state.isSolutionShown) {
        for (var i = 0; i < this.state.solution.length && i < this.state.initialItems.length; i++) {
          // var refOfSolution = "TeXEditor-Solution-" + i;
          this.textEditors[i]._forceRenderWithContent(this.state.initialItems[i] ? this.state.initialItems[i].value : null);
        }
      }
    });
  },
  textEditors: [],
  toggleSolution: function (e) {
    var solution = this.state.solution;
    var isChecked = e.target.checked;
    var isSolutionShown = this.state.isSolutionShown
    if (isSolutionShown) solution.splice(0, solution.length);
    else if (isChecked && solution.length <= 0) solution.push(this.newSolution());
    this.setState({
      isSolutionShown: !this.state.isSolutionShown,
      solution: solution
    });
  },
  newSolution: function () {
    return {
      type: 'TEXT',
      value: '',
      asHint: this.state.asHint
    }
  },
  toggleAnswer: function (e) {
    var isChecked = e.target.checked;
    this.state.kquestion.textInputAnswers[this.props.partIndex].type = isChecked ? 'AUTO_MARKING' : 'MANUAL_MARKING';
    this.forceUpdate();
  },
  toggleWiris: function(textInput, e) {
    var isChecked = e.target.checked;
    textInput.editorType = isChecked ? 'WIRIS' : 'NORMAL';
    textInput.text = '';
    this.forceUpdate();
  },
  handlePreTextChange: function (textInput, e) {
    textInput.preText = e.target.value;
    this.forceUpdate();
  },
  handlePostTextChange: function (textInput, e) {
    textInput.postText = e.target.value;
    this.forceUpdate();
  },
  handleAnswerChange: function(textInput, text) {
    if (textInput.editorType === 'WIRIS') textInput.text = text;
    else textInput.text = text.target.value;
    this.forceUpdate();
  },
  toggleHint: function () {
    var solution = this.state.solution;
    var isSolutionShown = this.state.isSolutionShown
    if (!this.state.asHint && isSolutionShown) {
      if (solution.length < MIN_SOLUTION_AS_HINT) {
        var diff = MIN_SOLUTION_AS_HINT - solution.length;
        for (var i = 0; i < diff; i++) solution.push(this.newSolution());
      }
      for (var j = 0; j < solution.length; j++) {
        if (j === solution.length - 1) solution[j].asHint = false;
        else solution[j].asHint = !solution[j].asHint;
      }
    } else {
      solution.forEach(sol => sol.asHint = false);
    }
    this.setState({
      asHint: !this.state.asHint,
      solution: solution,
    });
  },
  verifySolutionData: function (solution) {
    var isSolutionShown = false,
      asHint = false;
    if (!solution || solution.length <= 0) {
      isSolutionShown = false;
      asHint = false;
    } else {
      for (var i = 0; i < solution.length; i++) {
        var curSolution = solution[i];
        if (curSolution.value) {
          isSolutionShown = true;
        }
        if (curSolution.value && curSolution.asHint) {
          asHint = true;
          break;
        }
      }
    }
    return {
      isSolutionShown: isSolutionShown,
      asHint: asHint
    }
  },

  removeSolution: function (sol) {
    var _this = this;
    const { solution, initialItems, isSolutionShown, isAnswerShown, asHint } = this.state;
    var solutionIndex = solution.indexOf(sol);
    solution.splice(solutionIndex, 1);
    initialItems.splice(solutionIndex, 1);
    var result = this.verifySolutionData(solution);
    this.setState({
      initialItems,
      solution,
      isSolutionShown: isSolutionShown && (solution.length > 0),
      isAnswerShown: isAnswerShown,
      asHint: asHint && (solution.length > 1)
    }, function () {
      if (this.state.isSolutionShown) {
        for (var i = 0; i < this.state.solution.length && i < this.state.initialItems.length; i++) {
          // var refOfSolution = "TeXEditor-Solution-" + i;
          _this.textEditors[i]._forceRenderWithContent(_this.state.initialItems[i] ? _this.state.initialItems[i].value : null);
        }
      }
    });
  },

  onUpdateSolutionContent: function(solution, event) {
    var HTMLContent = event.editor.getData();
    var rawContent = HTMLContent;
    solution.value = HTMLContent;
    this.forceUpdate();
    if (this.props.onUpdateSolution && typeof this.props.onUpdateSolution === 'function')
      this.props.onUpdateSolution(rawContent, this.state.solution.indexOf(solution));
  },

  onUpdateSolutionContentTex: function (solution, HTMLContent, rawContent) {
    solution.value = HTMLContent;
    this.forceUpdate();
    if (this.props.onUpdateSolution && typeof this.props.onUpdateSolution === 'function')
      this.props.onUpdateSolution(rawContent, this.state.solution.indexOf(solution));
  },


  getInitialState: function() {

    return {
      isSolutionShown: false,
      solution: this.props.solution,
      asHint: false,
      initialItems: this.props.initialItems,
      kquestion: this.props.kquestion || {},
      isMathSubject: this.props.subject === "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"
    }
  },

  componentWillReceiveProps: function (nextProps) {
    var result = this.verifySolutionData(nextProps.solution);
    if (nextProps.solution && nextProps.solution.length > 0) {
    }
    else {
      if (!nextProps.solution) nextProps.solution = [];
      // nextProps.solution.push(this.newSolution());
    }
    var isMathSubject = this.state.isMathSubject
    var textInput = nextProps.kquestion.textInputAnswers[nextProps.partIndex];
    if (!textInput.editorType) textInput.editorType = 'WIRIS';
    console.log('next Props =======>', nextProps.kquestion)
    // if (nextProps.kquestion.concepts) {
    //   var kquestionConceptsLength = nextProps.kquestion.concepts.length;
    //   if (nextProps.kquestion.concepts[kquestionConceptsLength - 2] === "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c") {
    //     isMathSubject = true;
    //   } else {
    //     isMathSubject = false;
    //   }
    // }
    isMathSubject = nextProps.subject === "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"

    this.setState({
      initialItems: nextProps.initialItems ? nextProps.initialItems : this.state.initialItems,
      solution: nextProps.solution,
      asHint: result.asHint || this.state.asHint,
      isSolutionShown: result.isSolutionShown || this.state.isSolutionShown,
      kquestion: nextProps.kquestion,
      isMathSubject: isMathSubject
    });
  },

  componentWillMount: function () {
    var result = this.verifySolutionData(this.state.solution);
    this.setState({
      asHint: result.asHint,
      isSolutionShown: result.isSolutionShown
    });
  },

  render: function () {
    var _this = this;
    var _textInput = _this.state.kquestion.textInputAnswers[_this.props.partIndex];
    console.log(_textInput)
    return (
      <div className="solution-container">
        <div className="dp-table" style={{ "marginBottom": "10px" }}>
          <div className="dp-table-cell">
            <Toggle label="Solution" labelPosition="right" onToggle={_this.toggleSolution} defaultToggled={_this.state.isSolutionShown} />
          </div>
          <div className="dp-table-cell">
            <Checkbox defaultChecked={_this.state.asHint} label="Treat as Hint" className="dp-table-cell" onCheck={_this.toggleHint} />
          </div>
          {
            _this.state.isMathSubject &&
            <div className="dp-table-cell">
              <Toggle label="Answer" labelPosition="right" onToggle={_this.toggleAnswer} defaultToggled={_this.state.kquestion.textInputAnswers[_this.props.partIndex].type === 'AUTO_MARKING'}/>
            </div>
          }
        </div>
        {
          _this.state.kquestion.textInputAnswers[_this.props.partIndex].type === 'AUTO_MARKING' && 
          <div style={{margin: "20px"}}>
            {_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' ?<Toggle label="Use Wiris" labelPosition="right" onToggle={_this.toggleWiris.bind(_this, _textInput)} defaultToggled={_textInput.editorType === 'WIRIS'}/> : null }
            <div className="row">
              <div className="col-md-3"  >
              {_textInput.editorType !== 'WIRIS' && _this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' 
                ?<input className={"form-control answer-pretext-" + _this.props.questionIndex + _this.props.partIndex} type="text" placeholder="Pre-text" onChange={_this.handlePreTextChange.bind(_this, _textInput)} value={_textInput.preText} />
                :<input style={{marginTop: 100}} className={"form-control answer-pretext-" + _this.props.questionIndex + _this.props.partIndex} type="text" placeholder="Pre-text" onChange={_this.handlePreTextChange.bind(_this, _textInput)} value={_textInput.preText} />
              }
              </div>
              <div className="col-md-6">

              {_textInput.editorType !== 'WIRIS' && _this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' 
                ? <input className={"form-control answer-text-" +_this.props.questionIndex+_this.props.partIndex} type="text" placeholder="Answer here" onChange={_this.handleAnswerChange.bind(_this, _textInput)} value={_textInput.text}/>
                : <WirisEditor className="form-control" type="text" placeholder="Answer here" onChange={_this.handleAnswerChange.bind(_this, _textInput)} content={_textInput.text}/>
      
              }
                <p className={"alert-input-"+_this.props.questionIndex+_this.props.partIndex} style={{color: "red"}}></p>
              </div>
              <div className="col-md-3">
              {_textInput.editorType !== 'WIRIS' && _this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' 
                ?<input className={"form-control answer-posttext-" + _this.props.questionIndex + _this.props.partIndex} type="text" placeholder="Post-text" onChange={_this.handlePostTextChange.bind(_this, _textInput)} value={_textInput.postText} />
                :<input style={{marginTop:100}} className={"form-control answer-posttext-" + _this.props.questionIndex + _this.props.partIndex} type="text" placeholder="Post-text" onChange={_this.handlePostTextChange.bind(_this, _textInput)} value={_textInput.postText} />
              }
              </div>
            </div>
          </div>
        }
        {
          _this.state.isSolutionShown &&
          <div>
            <div className="solution-items">
              {
                _this.state.solution.map(function (solution, index, arr) {
                  return (
                    <div key={index} className="margin-bottom-15" style={{position: "relative"}}>
                      <div style={{paddingLeft: "75px", paddingRight: "30px"}}>
                        {_this.state.kquestion.subtype&& _this.state.kquestion.subtype.editor === 'old' ?
                        <TeXEditor
                          placeholder="Enter your solution here"
                          onUpdateContent={_this.onUpdateSolutionContentTex.bind(_this, solution)}
                          initialContent={(_this.state.initialItems && _this.state.initialItems[index]) ? _this.state.initialItems[index].value : null}
                          ref={x => _this.textEditors.splice(index, 1, x)}
                        />
                      : 
                        <CustomEditor
                          content={(_this.state.initialItems && _this.state.initialItems[index]) ? _this.state.initialItems[index].value : null}
                          events={{
                            "change": _this.onUpdateSolutionContent.bind(_this, solution)
                          }}
                        />
                      }

                      </div>
                      {
                        !(arr.length === index + 1 && _this.state.asHint) &&
                        <div>
                          <div style={{ position: "absolute", top: 0, right: 0 }}>
                            <i
                              data-tip data-for={"tt-solution-" + index}
                              className="fa fa-times"
                              style={{ fontSize: "14px", cursor: "pointer" }}
                              onClick={_this.removeSolution.bind(_this, solution)}></i>
                          </div>
                          <ReactTooltip
                            id={"tt-solution-" + index}
                            effect="solid"
                            place="left">
                            Remove solution
                          </ReactTooltip>
                        </div>
                      }
                      {
                        _this.state.asHint &&
                        <span style={{ "position": "absolute", "top": 0, "left": 0, "width": "70px" }}>{_this.state.asHint && _this.state.solution.length === index + 1 ? 'Not shown' : 'Hint ' + (index + 1)}</span>
                      }
                    </div>
                  )
                })
              }
            </div>
            <div className="actions">
              <RaisedButton
                onClick={this.addSolution}
                target="_blank"
                label="Add item"
                primary={true}
                icon={<i style={{ "color": "white" }} className="fa fa-plus" />}
              />
            </div>
          </div>
        }


      </div>
    );
  },

  componentDidMount: function () {
    var _this = this;
    var kquestion = this.props.kquestion;
    var partIndex = this.props.partIndex;

    // Check if this question is a concept of Math subject, show "Answer" slide button
    if (kquestion.concepts) {
      var kquestionConceptsLength = kquestion.concepts.length;
      if (kquestion.concepts[kquestionConceptsLength - 2] === "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c") {
        _this.setState({
          isMathSubject: true
        })
      }
    }
  }

});

module.exports = Solution4LongQ;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/Solution4LongQ.js
 **/